var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "login-container" },
    [
      _c(
        "el-form",
        {
          ref: "register",
          staticClass: "login-form",
          attrs: {
            model: _vm.registerData,
            "auto-complete": "on",
            "label-position": "left"
          }
        },
        [
          _c("div", { staticClass: "title-container" }, [
            _c("h3", { staticClass: "title" }, [_vm._v("注册")])
          ]),
          _c(
            "el-form-item",
            { attrs: { prop: "phone" } },
            [
              _c("span", { staticClass: "svg-container" }, [
                _c("i", { staticClass: "iconfont icon-lujing" })
              ]),
              _c("el-input", {
                ref: "phone",
                attrs: {
                  placeholder: "手机号",
                  name: "phone",
                  type: "text",
                  tabindex: "1",
                  "auto-complete": "on",
                  maxlength: "11"
                },
                model: {
                  value: _vm.registerData.phone,
                  callback: function($$v) {
                    _vm.$set(_vm.registerData, "phone", $$v)
                  },
                  expression: "registerData.phone"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { prop: "verificationCode" } },
            [
              _c("span", { staticClass: "svg-container" }, [
                _c("i", { staticClass: "iconfont icon-yanzhengma" })
              ]),
              _c("el-input", {
                ref: "verificationCode",
                attrs: {
                  placeholder: "验证码",
                  name: "verificationCode",
                  type: "text",
                  tabindex: "1",
                  "auto-complete": "on"
                },
                model: {
                  value: _vm.registerData.verificationCode,
                  callback: function($$v) {
                    _vm.$set(_vm.registerData, "verificationCode", $$v)
                  },
                  expression: "registerData.verificationCode"
                }
              }),
              _c(
                "el-button",
                {
                  staticClass: "get-code",
                  attrs: { disabled: _vm.disabled, type: "text" },
                  on: { click: _vm.getCode }
                },
                [_vm._v(_vm._s(_vm.text))]
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { prop: "role" } },
            [
              _c("span", { staticClass: "svg-container" }, [
                _c("i", { staticClass: "iconfont icon-user1" })
              ]),
              _c(
                "el-select",
                {
                  staticStyle: { width: "100%" },
                  attrs: { placeholder: "注册身份" },
                  model: {
                    value: _vm.registerData.type,
                    callback: function($$v) {
                      _vm.$set(_vm.registerData, "type", $$v)
                    },
                    expression: "registerData.type"
                  }
                },
                _vm._l(_vm.typeList, function(item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { prop: "password" } },
            [
              _c("span", { staticClass: "svg-container" }, [
                _c("i", { staticClass: "iconfont icon-password" })
              ]),
              _c("el-input", {
                key: _vm.passwordType,
                ref: "password",
                attrs: {
                  type: _vm.passwordType,
                  placeholder: "密码",
                  name: "password",
                  tabindex: "2",
                  "auto-complete": "on"
                },
                nativeOn: {
                  keyup: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.handleLogin($event)
                  }
                },
                model: {
                  value: _vm.registerData.password,
                  callback: function($$v) {
                    _vm.$set(_vm.registerData, "password", $$v)
                  },
                  expression: "registerData.password"
                }
              }),
              _c(
                "span",
                { staticClass: "show-pwd", on: { click: _vm.showPwd } },
                [
                  _c("i", {
                    class: [
                      "iconfont",
                      _vm.passwordType === "password" ? "icon-eye1" : "icon-eye"
                    ]
                  })
                ]
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { prop: "invitationCode" } },
            [
              _c("span", { staticClass: "svg-container" }, [
                _c("i", { staticClass: "iconfont icon-yaoqing" })
              ]),
              _c("el-input", {
                ref: "invitationCode",
                attrs: {
                  placeholder: "邀请码（可不填）",
                  name: "invitationCode",
                  type: "text",
                  tabindex: "1",
                  "auto-complete": "on"
                },
                model: {
                  value: _vm.registerData.invitationCode,
                  callback: function($$v) {
                    _vm.$set(_vm.registerData, "invitationCode", $$v)
                  },
                  expression: "registerData.invitationCode"
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticStyle: { "font-size": "14px", color: "#fff" } },
            [
              _vm._v("已有账号 "),
              _c(
                "el-button",
                { attrs: { type: "text" }, on: { click: _vm.gotoLogin } },
                [_vm._v("去登录")]
              )
            ],
            1
          ),
          _c(
            "el-button",
            {
              staticStyle: { width: "100%", "margin-bottom": "30px" },
              attrs: { loading: _vm.loading, type: "primary" },
              on: { click: _vm.register }
            },
            [_vm._v("注册")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }